import { isEmptyOrWhiteSpace } from "@/utils/Common";
import cloneDeep from "lodash/cloneDeep";
import { PluginObject } from "vue";

export function toObjectString(value: any) {
  return JSON.stringify(value || {});
}

export function parseObject(value: any) {
  if (typeof value !== "string") {
    return value;
  }
  if (isEmptyOrWhiteSpace(value)) {
    return {};
  }
  return JSON.parse(value);
}

export function cloneData(value: any) {
  return cloneDeep(value);
}

const plugin: PluginObject<any> = {
  install(Vue) {
    Vue.filter("toObjectString", toObjectString);
    Vue.filter("parseObject", parseObject);
    Vue.filter("cloneData", cloneData);
  }
};

export default plugin;
